import {defineStore} from 'pinia'
import type {UserInfoType} from '~/utils/types'

const defaultUser = (): UserInfoType => ({
    id: null,
    name: '',
    lastName: '',
    email: '',
    phone: '',
    description: '',
    avatar: '',
    links: [],
    type: {},
    dtCreated: ''
})

export const useUserStore = defineStore('user', () => {

    const userInfo = ref<UserInfoType>(defaultUser())

    const fetchUserSSR = async () => {
        await useNuxtApp().runWithContext(async () => {
            const {$ProfileApi} = useNuxtApp()
            const response = await $ProfileApi.getUserProfile({})
                .catch(error => {
                    return defaultUser()
                })
            userInfo.value = {...defaultUser(), ...response}
        })
    }

    const updateUser = (newData: Partial<UserInfoType>) => {
        userInfo.value = {...userInfo.value, ...newData}
    }

    const clearUser = () => {
        userInfo.value = defaultUser()
    }

    return {
        userInfo,
        fetchUserSSR,
        updateUser,
        clearUser
    }
})
